import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaEventosCulturales from './TablaEventosCulturales';

const EventosCulturales: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaEventosCulturales />
    </Box>
  );
};

export default EventosCulturales;
